import { render, staticRenderFns } from "./ListarVendaCard.vue?vue&type=template&id=d63b9cdc"
import script from "./ListarVendaCard.vue?vue&type=script&lang=js"
export * from "./ListarVendaCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports